import React, { useEffect, useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../components/collapseAbleTable/CollapseableTable";
import { Table } from "antd";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import useGetAttributesWithSubType from "../../hooks/useGetAttributesWithSubType";
import useGetAttributes from "../../hooks/useGetAttributes";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import useCreateAttribute from "../../hooks/useCreateAttribute";
import UseUpdate from "../../hooks/UseUpdate";
import useDeleteItem from "../../hooks/useDeleteItem";
import useFetchItems from "../../hooks/useFetchItems";
import { communicationColumns } from "./AllColumnsData";
import useModalHandlers from "../../hooks/useModalHandler";
import useFetchPasswords from "../../hooks/useFetchPasswords";
import useChangeHandler from "../../hooks/useChangeHandler";
import * as Style from "../../../../../newComponents/styledComponents/PersonalInstruction";
import DEATH_API from "../../../../../apis/death.api";
import { Modal } from "antd";
import swal from "sweetalert";
import useFetchContacts from "../../hooks/useFetchContacts";
import useCreateAttributeWithSubType from "../../hooks/useCreateAttributesWithSubType";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

const MODULE_NAMES = [
  "Communication Plan",
  "Emergency Alert Subscriptions",
  "Backup Communication Devices",
  "Out-of-state Contact Person Communication Plan",
  "Social Media Accounts",
];

export default function CommunicationPlan(props) {
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Communication Plan");
  const [formData, setFormData] = useState(null);
  const [attributesData, setAttributesData] = useState(null);
  const [isOtpModalVisible, setIsOtpModalVisible] = useState(true);
  const [listofPassword, setListofPassword] = useState([]);
  const [message, setMessage] = useState("");
  const [userData, setUserData] = useState(null);
  const history = useHistory();

  const {
    fetchData,
    fetchDataWithSubType,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useFetchItems(MODULE_NAMES, setLoading);

  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const { createAttributeWithSubType } = useCreateAttributeWithSubType(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchDataWithSubType,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const { deleteRecord } = useDeleteItem(
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const { attributes, disasterAttribute } = useGetAttributes(
    MODULE_NAMES,
    setLoading
  );

  console.log("Attributes are here", attributes);

  const { showModal, updateModal, viewModal, handelCloseModal } =
    useModalHandlers(
      attributes,
      setModalTitle,
      setModuleName,
      setIsModalVisible,
      setFormData,
      setAttributesData
    );

  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  const { contactList } = useFetchContacts(setLoading);
  const { passwordList } = useFetchPasswords();

  const AddContact = () => {
    history.push("/client/plan");
  };

  const communicationTables = [
    {
      title: "Out-of-state Contact Person",
      key: 1,
      backendName: "Out-of-state Contact Person Communication Plan",
    },
    {
      title: "Social Media Accounts",
      key: 2,
      backendName: "Social Media Accounts",
    },
    {
      title: "Emergency Alert Subscriptions",
      key: 3,
      backendName: "Emergency Alert Subscriptions",
    },
    {
      title: "Backup Communication Devices",
      key: 4,
      backendName: "Backup Communication Devices",
    },
  ];

  const tableDataObj = {
    "Communication Plan": tableData.communicationPlanData,
    "Out-of-state Contact Person Communication Plan":
      tableData.outofstateContactPersonCommunicationPlanData,
    "Social Media Accounts": tableData.socialMediaAccountsData,
    "Emergency Alert Subscriptions": tableData.emergencyAlertSubscriptionsData,
    "Backup Communication Devices": tableData.backupCommunicationDevicesData,
  };

  console.log("Table Data Communication", tableData);
  const AllColumnsData = communicationColumns(
    viewModal,
    updateModal,
    deleteRecord
  );

  console.log("Form Data Communication", formData);
  const handleFormDataUpdate = (formData) => {
    const Payload = {
      Name: formData && formData.name,
      "Phone Number": formData && formData.phoneNumber,
      Relationship: formData && formData.typeOfRelation,
      Street: formData && formData.homeStreet,
      State: formData && formData.homeSate,
      City: formData && formData.homeCity,
      Company: formData && formData.jobCompany,
    };

    console.log("Payload to update formData Communication:", Payload);

    setFormData((prev) => ({
      ...prev,
      ...Payload,
    }));
  };

  const handleCancel = () => {
    setIsOtpModalVisible(false);
    localStorage.setItem("otp", "");
  };

  const handleOk = async () => {
    setLoading(true);
    try {
      const ID = localStorage.getItem("accessId");
      const otp = userData && userData.otp;
      const data = await DEATH_API.fetchPasswords(otp, ID);
      setMessage(data);

      if (data && data.status === 200) {
        localStorage.setItem("otp", otp);
        if (data.data) {
          setListofPassword(data.data);
        }
        setLoading(false);
        setIsOtpModalVisible(false);
      } else {
        swal("Oops!", "Invalid OTP", "error");
      }
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
    }
  };

  const cols = [
    {
      title: "Site/App/Program",
      dataIndex: "appName",
      render: (record) => record || "N/A",
    },
    {
      title: "UserName",
      dataIndex: "userName",
      render: (record) => record || "N/A",
    },
    {
      title: "Who's Password",
      dataIndex: "passwordFor",
      render: (record) => record || "N/A",
    },
    {
      title: "Password Hint",
      dataIndex: "passwordHint",
      render: (record) => record || "N/A",
    },
    {
      title: "Website URL",
      dataIndex: "appUrl",
      render: (record) => record || "N/A",
    },
    {
      title: "2FA",
      dataIndex: "twoFactor",
      render: (record) => record || "N/A",
    },
    { title: "Pin", dataIndex: "pin", render: (record) => record || "N/A" },
    {
      title: "Security Question",
      dataIndex: "securityQuestion",
      render: (record) => record || "N/A",
    },
    {
      title: "Answer",
      dataIndex: "answer",
      render: (record) => record || "N/A",
    },
    { title: "Notes", dataIndex: "note", render: (record) => record || "N/A" },
  ];

  const getPasswordList = async () => {
    if (props.role === "protrustee") {
      isSecondPasswordGranted();
    } else {
      if (!localStorage.getItem("otp")) {
        localStorage.setItem("otp", "");
      }
      if (localStorage.getItem("otp") === "") {
        showModalOtp();
      } else {
        setLoading(true);
        if (localStorage.getItem("otp")) {
          const ID = localStorage.getItem("accessId");
          const data = await DEATH_API.fetchPasswords(
            localStorage.getItem("otp"),
            ID
          );
          if (data.message === "This is an expired OTP") {
            showModalOtp();
          } else if (data && data.data) {
            setListofPassword(data.data);
          }
          setLoading(false);
        }
      }
    }
  };

  const isSecondPasswordGranted = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      const data = await DEATH_API.getSecondPasswordStatus(ID);
      setLoading(false);

      if (data.date.secondPasswordGranted === 1) {
        if (!localStorage.getItem("otp")) {
          localStorage.setItem("otp", "");
        }
        if (localStorage.getItem("otp") === "") {
          showModalOtp();
        } else {
          setLoading(true);
          if (localStorage.getItem("otp")) {
            const ID = localStorage.getItem("accessId");
            const data = await DEATH_API.fetchPasswords(
              localStorage.getItem("otp"),
              ID
            );
            if (data.message === "This is an expired OTP") {
              showModalOtp();
            } else if (data && data.data) {
              setListofPassword(data.data);
            }
            setLoading(false);
          }
        }
      } else {
        swal("Oops!", "Second password is required.", "error");
        setLoading(false);
      }
    } catch (error) {
      swal("Oops!", "Error fetching password data.", "error");
      setLoading(false);
    }
  };

  const showModalOtp = async () => {
    setIsOtpModalVisible(true);
    try {
      const ID = localStorage.getItem("accessId");
      const data = await DEATH_API.configOtp(ID);
      swal(data.message);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const handleInputChange = (name, value) => {
    setUserData({
      ...userData,
      [name]: value,
    });
  };
  const handleKeyPress = (event) => {
    console.log("submit");
    if (event.key === "Enter") {
      handleOk();
    }
  };
  useEffect(() => {
    getPasswordList();
  }, []);

  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <h2 className="parent-title">Communication Plan</h2>
        <ToolTipCreator name={"Disaster_Communciation_Plan"}/>
      </div>
        {/* <div className="parent-icon-container">
          <img
            src={helpIcon}
            alt="help icon"
            width="18.67px"
            height="18.67px"
          />
        </div> */}
      </div>

      {disasterAttribute && (
        <>
          <DisabilityFormCreator
            data={disasterAttribute}
            values={disasterAttributeData}
            setSubmitBody={setFormData}
          />
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={async () => {
                if (toUpdate) {
                  await updateRecord();
                } else {
                  await createAttributes();
                }
              }}
            >
              {toUpdate ? "Update" : "Submit"}
            </button>
          </div>
        </>
      )}

      {communicationTables.map((table) => (
        <CollapseableTable
          title={table.title} // Display name
          key={table.key}
          formData={formData}
          setFormData={setFormData}
          setModuleName={() => setModuleName(table.backendName)}
          options={contactList}
          handleFormDataUpdate={handleFormDataUpdate}
          createAttributes={createAttributes}
          onClick={() => {
            if (table.key === 1) {
              AddContact();
            } else {
              showModal(table.backendName);
            }
          }}
        >
          <Table
            columns={AllColumnsData[table.backendName]}
            dataSource={tableDataObj[table.backendName]}
          />
        </CollapseableTable>
      ))}

      <CustomModal
        show={isModalVisible}
        fields={attributesData}
        modalTitle={modalTitle}
        close={handelCloseModal}
        onChange={handleChange}
        onSelectChange={handleItemsInfoSelect}
        submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
        selectedRowData={formData}
        handleItemsInfoImageChange={formData}
        loading={loading}
      />

      <div className="parent-title-container">
        <h2 className="parent-title">Passwords</h2>
        <div className="parent-icon-container">
          <img
            src={helpIcon}
            alt="help icon"
            width="18.67px"
            height="18.67px"
          />
        </div>
      </div>

      <CollapseableTable title={"All Passwords"} key={5} show={true}>
        <Table columns={cols} dataSource={listofPassword} />
      </CollapseableTable>

      <NewLoader isLoading={loading} />

      <Modal
        visible={isOtpModalVisible}
        footer={null}
        closable={false}
        centered
      >
        <div style={{ marginTop: "20px" }}>
          <h3 style={{ color: "#4d5e80", marginBottom: "10px" }}>
            List of Passwords
          </h3>
          <div className="">
            <h2 className="otp-heading" style={{ color: "#4d5e80" }}>
              This passcode provides another layer of security for your list of
              passwords. The passcode is only valid for this session.
            </h2>
            <div>
              <Style.Input
                onKeyPress={handleKeyPress}
                onChange={(e) => {
                  e.preventDefault();
                  handleInputChange(e.target.name, e.target.value);
                }}
                id="otp"
                type="text"
                pattern="[0-9.]+"
                maxLength={6}
                placeholder="***OTP***"
                name="otp"
              />

              <Style.ResendButton
                onClick={async () => {
                  setLoading(true);
                  try {
                    let data = await DEATH_API.configOtp();
                    if (data && data.message) {
                      swal("Success", data.message, "success");
                    }
                  } catch (error) {
                    console.log("error", error);
                  }
                  setLoading(false);
                }}
              >
                Resend OTP
              </Style.ResendButton>

              <Style.WrapperButtons>
                <Style.CancelButton onClick={handleCancel}>
                  Cancel
                </Style.CancelButton>
                <Style.SaveButton onClick={handleOk}>Done</Style.SaveButton>
              </Style.WrapperButtons>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
